export function getUserRole({ merchantId, roles }) {
  const role = roles.find((r) => r.merchant.id === merchantId);
  return role ? role.name : 'unknown';
}
